import * as React from "react";
import { Typography, Box, Skeleton } from "@mui/material";
import RightLeftChecker from "../../../../utils/RightLeftChecker";

const AboutDescription = ({ about }) => {
  return (
    <Box>
      {about ? (
        <Typography
          sx={{
            fontSize: "18px",
            fontWeight: "600",
            lineHeight: "28px",
            marginBottom: "8px",
          }}
        >
          About:
        </Typography>
      ) : (
        <Skeleton sx={{ mb: "8px" }} width={95} height={25} />
      )}
      {about && (
        <Typography
          sx={{
            paddingBottom: "27px",
            fontSize: "16px",
            userSelect: "text",
            direction: RightLeftChecker(about?.description) ? "rtl" : "ltr",
          }}
        >
          {about.description}
        </Typography>
      )}

      {!about && (
        <>
          <Skeleton width='100%' height={28} />
          <Skeleton width='100%' height={28} />
          <Skeleton width='100%' height={28} />
          <Skeleton width='100%' height={28} />
          <Skeleton width='65%' height={28} />
        </>
      )}
    </Box>
  );
};
export default AboutDescription;
